import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchCostSheets,
  fetchOrganiserEvents,
} from "../redux/eventOrganiserThunks";
import userStore from "../../../zustand/userStore";
import axios from "axios";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import { MapCostSheetActivity } from "../../../configs/WebService";

const EventActivity = ({ isOpen, data, setDataTableDatas }) => {
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);
  const events = useSelector((state) => state.eventOrganiser.Events) || [];
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);

  useEffect(() => {
    if (userData?.id) {
      dispatch(fetchOrganiserEvents({ userId: userData.id }));
    }
  }, [dispatch, userData]);

  const handleEventChange = (eventId) => {
    const event = events.find((e) => e.id === parseInt(eventId));
    setSelectedEvent(event);
    setSelectedActivity(null);
  };

  const handleActivityChange = (activityId) => {
    const activity = selectedEvent?.activities.find(
      (a) => a.id === parseInt(activityId)
    );
    setSelectedActivity(activity);
  };

  const handleSubmit = async () => {
    if (selectedEvent && selectedActivity) {
      const payload = {
        activityId: selectedActivity.id,
        costSheetId: data.id,
        userId: userData.id,
        // orgId: userData.org.id,
      };

      try {
        const response = await axios.post(MapCostSheetActivity, payload, {
          headers: apiKeyHeader(),
        });

        console.log("resultData", response.data);
        // dispatch(
        //   fetchCostSheets({ orgId: userData.org.id, userId: userData.id })
        // );
        // const actionResult = await dispatch(
        //   fetchCostSheets({ orgId: userData.org.id, userId: userData.id })
        // );

        // if (fetchCostSheets.fulfilled.match(actionResult)) {
        //   setDataTableDatas(actionResult.payload);
        // } else {
        //   console.error("Failed to fetch cost sheets:", actionResult.payload);
        // }
        window.location.reload();
        isOpen(false);
      } catch (error) {
        console.error("Error submitting activity:", error);
      }
    }
  };

  return (
    <div className="space-y-4 p-4">
      <div>
        <label
          htmlFor="event-select"
          className="block text-sm font-medium text-gray-700"
        >
          Select Event
        </label>
        <select
          id="event-select"
          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md border"
          value={selectedEvent?.id || ""}
          onChange={(e) => handleEventChange(e.target.value)}
        >
          <option value="">-- Select an Event --</option>
          {events.map((event) => (
            <option key={event.id} value={event.id}>
              {event.name} ({event.date})
            </option>
          ))}
        </select>
      </div>

      {selectedEvent && (
        <div>
          <label
            htmlFor="activity-select"
            className="block text-sm font-medium text-gray-700"
          >
            Select Activity
          </label>
          <select
            id="activity-select"
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md border"
            value={selectedActivity?.id || ""}
            onChange={(e) => handleActivityChange(e.target.value)}
            disabled={!selectedEvent?.activities?.length}
          >
            <option value="">-- Select an Activity --</option>
            {selectedEvent.activities.map((activity) => (
              <option key={activity.id} value={activity.id}>
                {activity.name}
              </option>
            ))}
          </select>
        </div>
      )}

      {selectedEvent && selectedActivity && (
        <button
          onClick={handleSubmit}
          className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
          style={{
            borderRadius: "5px",
            backgroundColor: "blue",
            borderStyle: "none",
            color: "white",
          }}
        >
          Submit
        </button>
      )}
    </div>
  );
};

export default EventActivity;
